import { initRumBundle } from '@adv-frontend/rum-kit';
import { initRumInline, InitRumInlineOptions } from '@adv-frontend/rum-kit/inline';

export type InitRumConfig = InitRumInlineOptions;

export const initRum = (config: InitRumConfig) => {
    initRumInline(config);
    initRumBundle();
};
